import { render, staticRenderFns } from "./Withdrawals.vue?vue&type=template&id=407015dc&"
import script from "./Withdrawals.vue?vue&type=script&lang=js&"
export * from "./Withdrawals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports